const MILLISECONDS_PER_DAY =
  1000 * 60 * 60 * 24;

export function calculateRemainingDays(
  expiresAt,
) {
  if (!expiresAt) {
    return null;
  }

  const expirationTime =
    new Date(expiresAt).getTime();

  if (!Number.isFinite(expirationTime)) {
    return null;
  }

  const difference =
    expirationTime - Date.now();

  if (difference <= 0) {
    return 0;
  }

  return Math.ceil(
    difference / MILLISECONDS_PER_DAY,
  );
}

export function getLicenseStatus(
  remainingDays,
) {
  if (remainingDays === null) {
    return 'notApplicable';
  }

  if (remainingDays <= 0) {
    return 'expired';
  }

  if (remainingDays <= 30) {
    return 'expiring';
  }

  return 'active';
}

export function formatLicenseDate(
  dateValue,
  language = 'ko',
) {
  if (!dateValue) {
    return '-';
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  const locale =
    language === 'en'
      ? 'en-US'
      : 'ko-KR';

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

export function maskLicenseKey(
  licenseKey,
) {
  const normalizedKey =
    String(licenseKey || '');

  const parts =
    normalizedKey.split('-');

  if (parts.length >= 3) {
    return parts
      .map((part, index) => {
        const isVisiblePart =
          index === 0 ||
          index === parts.length - 1;

        return isVisiblePart
          ? part
          : '••••';
      })
      .join('-');
  }

  if (normalizedKey.length <= 8) {
    return normalizedKey;
  }

  return `${normalizedKey.slice(
    0,
    4,
  )}••••${normalizedKey.slice(-4)}`;
}